module.exports = __webpack_public_path__ + "img/请假申请.3a1e5012.png";